module.exports = __webpack_public_path__ + "static/media/intro.701fba04.jpg";